/**
 * 表示設定スナップショット（module-level singleton）
 *
 * @file displaySettingsSnapshot.ts
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * 非Reactモジュール（proxyServiceConfig / UnifiedErrorPage）が
 * DisplaySettings を参照するための module-level snapshot。
 * main.tsx が render 前に setDisplaySettingsSnapshot() で初期化する。
 */

export interface DisplaySettings {
  homepageNewArrivalsPcLimit: number;
  homepageNewArrivalsMobileLimit: number;
  homepageExternalProductsLimit: number;
  homepageCategoriesLimit: number;
  homepageFeaturedProductsLimit: number;
  errorPageRedirectSeconds: number;
  proxyServices: string[];
  featureChatSupport: boolean;
  notificationDefaultDurationSeconds: number;
  defaultLanguage: string;
  defaultCurrency: string;
}

let _snapshot: DisplaySettings | null = null;

export const setDisplaySettingsSnapshot = (s: DisplaySettings): void => {
  _snapshot = s;
};

export const getDisplaySettingsSnapshot = (): DisplaySettings => {
  if (!_snapshot) {
    throw new Error('[DisplaySettings] スナップショット未取得。main.tsx での初期化前に参照されました。');
  }
  return _snapshot;
};
